export enum StripeAccountType {
  StandardAccount = 1,
  CharityBasedConnectAccount = 2,
  GameBasedConnectAccount = 3
}
